export default Object.freeze({
  Counter: 1,
  Car: 2
});
